/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_View_AllInputs */

const vi_common_view_all = /** @type {(inputs: Common_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem tất cả`)
};

/**

* @param {Common_View_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_view_all = /** @type {((inputs?: Common_View_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_View_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_view_all(inputs)
});